import { EventCategory } from "@labs/shared/types/EventCategory.ts";

type GtagEventParameters = {
  label?: string;
  value?: number;
  [key: string]: string | number | undefined;
};

// This relies upon gtag being available on the window, so make that explicit.
// I initially tried to use the `react-ga4` package, but it is not up to date
// with the event syntax of GA4, despite the name
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (
      command: "event" | "js" | "config",
      eventName: string,
      eventParameters?: GtagEventParameters,
    ) => void;
  }
}

// allow node context to safely ignore window reference
declare const window: Window & typeof globalThis;

export const trackEvent = (
  category: EventCategory,
  action: string,
  label?: string,
  value?: number | string | boolean,
) => {
  try {
    const eventName = `${category.toLowerCase()}_${action.toLowerCase().replace(/ /g, "_")}`;

    const eventParameters: GtagEventParameters = {};

    if (label) {
      eventParameters.label = label;
    }

    if (value !== undefined) {
      eventParameters.value = Number(value);
    }

    if (typeof window !== "undefined") {
      window.gtag("event", eventName, eventParameters);
    }
  } catch (err) {
    console.error("Failed to track event:", err);
  }
};
